import { tokens, Typography } from '@sapphire-react/core';
import { useTranslation } from 'react-i18next';

const paragraphs = [
  'moreInformation.items.calculation.paragraph1',
  'moreInformation.items.calculation.paragraph2',
  'moreInformation.items.calculation.paragraph3',
];

const CreateSectionContent = () => {
  const { t } = useTranslation();

  return (
    <>
      <Typography.Body marginBottom={tokens.size.spacingMd}>
        {t(paragraphs[0])}
      </Typography.Body>
      <Typography.Body marginBottom={tokens.size.spacingMd}>
        {t(paragraphs[1])}
      </Typography.Body>
      <Typography.Body>{t(paragraphs[2])}</Typography.Body>
    </>
  );
};

export const howCalculatedData = {
  key: 'how-calculated-data',
  text: 'moreInformation.items.calculation.title',
  content: <CreateSectionContent />,
};
